<template>
  <div v-if="!loading && loadTable">
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="vx-card mb-4">
          <div class="vx-card__header">
            <div class="vx-card__title">
              <h4>{{ $t("PartyInfo") }}</h4>
            </div>
          </div>
          <div class="vx-card__collapsible-content vs-con-loading__container">
            <div class="vx-card__body custom-tbl">
              <vs-table :data="order" ref="table">
                <template slot="thead">
                  <vs-th style="width: 15%">{{ $t("Name") }}</vs-th>
                  <vs-th style="width: 15%">{{ $t("PartyType") }}</vs-th>
                  <vs-th
                    style="width: 15%"
                    v-if="order.orderPartyInfoQueryDto.partyType == 'حقیقی'"
                  >
                    {{ $t("SocialSecurityNumber") }}
                  </vs-th>
                  <vs-th
                    style="width: 15%"
                    v-if="order.orderPartyInfoQueryDto.partyType == 'حقوقی'"
                  >
                    {{ $t("CompanyNationalId") }}
                  </vs-th>
                  <vs-th style="width: 15%">{{ $t("PhoneNumber") }}</vs-th>
                  <vs-th style="width: 25%">{{ $t("Address") }}</vs-th>
                  <vs-th style="width: 15%">{{ $t("PostalCode") }}</vs-th>
                </template>
                <template :name="{ data }" slot-scope="{ data }">
                  <vs-tr>
                    <vs-td>
                      {{ order.orderPartyInfoQueryDto.name }}
                    </vs-td>
                    <vs-td>
                      {{ order.orderPartyInfoQueryDto.partyType }}
                    </vs-td>
                    <vs-td
                      v-if="order.orderPartyInfoQueryDto.partyType == 'حقیقی'"
                    >
                      <span
                        v-if="
                          !order.orderPartyInfoQueryDto.socialSecurityNumber
                        "
                      >
                        -
                      </span>
                      {{ order.orderPartyInfoQueryDto.socialSecurityNumber }}
                    </vs-td>
                    <vs-td
                      v-if="order.orderPartyInfoQueryDto.partyType == 'حقوقی'"
                    >
                      <span
                        v-if="!order.orderPartyInfoQueryDto.companyNationalId"
                      >
                        -
                      </span>
                      {{ order.orderPartyInfoQueryDto.companyNationalId }}
                    </vs-td>
                    <td
                      v-for="item in order.orderPartyInfoQueryDto
                        .orderPhonesQuery"
                      :key="item.id"
                      style="direction: ltr"
                    >
                      <span v-if="item.area">{{ item.area }}-</span>
                      {{ item.number }}
                    </td>
                    <td
                      v-for="item in order.orderPartyInfoQueryDto
                        .orderAddressesInfoQuery"
                      :key="item.id"
                    >
                      {{ item.orderProvinceInfoQuery.name }}-{{
                        item.orderProvinceInfoQuery.cityName
                      }}-{{ item.address }}
                    </td>
                    <td
                      v-for="item in order.orderPartyInfoQueryDto
                        .orderAddressesInfoQuery"
                      :key="item.id"
                    >
                      {{ item.postalCode }}
                    </td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="vx-card mb-4">
          <div class="vx-card__header">
            <div class="vx-card__title w-full">
              <h4>
                {{ $t("OrdersList") }}
                {{ $t("From") }}
                {{ $t("Contract") }}:
                <span class="color-primary">{{
                  order.orderContractQuery.contractTitle
                }}</span>
                <span class="date float-right">
                  <span> {{ $t("CreateOn") }}: </span>
                  <span class="float-right">
                    {{ order.createOn }}
                  </span>
                </span>
              </h4>
            </div>
          </div>
          <div class="vx-card__collapsible-content vs-con-loading__container">
            <div class="vx-card__body custom-tbl" id="draft-order-tbl">
              <vs-table :data="order.ordersItemsQueryDto" ref="table">
                <template slot="thead">
                  <vs-th style="width: 3%">#</vs-th>
                  <vs-th style="width: 18%">{{ $t("ProductName") }}</vs-th>
                  <vs-th style="width: 18%">{{ $t("ProductId") }}</vs-th>
                  <vs-th style="width: 18%">{{ $t("ItemCode") }}</vs-th>
                  <vs-th style="width: 5%">{{ $t("Count") }}</vs-th>
                  <vs-th style="width: 10%">{{ $t("UnitPrice") }}</vs-th>
                  <vs-th style="width: 10%">{{ $t("TotalAmount") }}</vs-th>
                  <vs-th style="width: 10%">{{ $t("UnitDiscount") }}</vs-th>
                  <vs-th style="width: 11%">{{ $t("SumOfDiscount") }}</vs-th>
                  <vs-th style="width: 11%">{{
                    $t("TotalAmountAfterDeductionOfDiscounts")
                  }}</vs-th>
                  <vs-th style="width: 10%">{{ $t("TotalTaxAmount") }}</vs-th>
                  <vs-th style="width: 12%">{{
                    $t("TotalAmountWithTax")
                  }}</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr
                    v-for="(tr, indextr) in data"
                    :data="tr"
                    :key="indextr"
                    style="font-size: 12px;"
                  >
                    <vs-td :data="data[indextr]">
                      {{ parseInt(indextr) + 1 }}
                    </vs-td>
                    <vs-td
                      :data="data[indextr].orderProductInfoQuery.productName"
                    >
                      {{ data[indextr].orderProductInfoQuery.productName }}
                    </vs-td>
                    <vs-td
                      :data="data[indextr].orderProductInfoQuery.identificationCode"
                    >
                      {{ data[indextr].orderProductInfoQuery.identificationCode }}
                    </vs-td>

                    <vs-td
                      :data="data[indextr].orderProductInfoQuery.itemCode"
                    >
                      {{ data[indextr].orderProductInfoQuery.itemCode }}
                    </vs-td>

                    <vs-td :data="data[indextr].count">
                      {{ data[indextr].count }}
                    </vs-td>
                    <vs-td :data="data[indextr].unitPrice">
                      <span class="ml-2" v-if="!iseditValueOrder">
                        {{
                          Number(data[indextr].unitPrice).toLocaleString()
                        }}</span
                      >
                      <input
                        class="ml-2 w-3/4 p-1"
                        v-model="unitPriceNewList[indextr]"
                        type="text"
                        v-else
                        style="color: white;background-color: #bbb;border-radius: 5px;border: 1px solid gray;"
                      />
                      <span :class="iseditValueOrder ? 'mt-2 m-0 p-0' : ''">
                        ریال</span
                      >
                    </vs-td>
                    <vs-td :data="data[indextr].totalAmount">
                      {{ Number(data[indextr].totalAmount).toLocaleString() }}
                      ریال
                    </vs-td>
                    <vs-td :data="data[indextr].unitDiscount">
                      <span class="ml-2" v-if="!iseditValueOrder">
                        {{
                          Number(data[indextr].unitDiscount).toLocaleString()
                        }}</span
                      >
                      <input
                        class="ml-2 w-3/4 p-1"
                        v-model="unitDiscountNewList[indextr]"
                        type="text"
                        v-else
                        style="color: white;background-color: #bbb;border-radius: 5px;border: 1px solid gray;"
                      />
                      <span :class="iseditValueOrder ? 'mt-2' : ''"> ریال</span>
                    </vs-td>
                    <vs-td :data="data[indextr].sumOfDiscount">
                      <span class="ml-2" v-if="!iseditValueOrder">
                        {{
                          Number(data[indextr].sumOfDiscount).toLocaleString()
                        }}</span
                      >
                      <input
                        class="ml-2 w-3/4 p-1"
                        v-model="sumOfDiscountNewList[indextr]"
                        type="text"
                        v-else
                        style="color: white;background-color: #bbb;border-radius: 5px;border: 1px solid gray;"
                      />
                      <span :class="iseditValueOrder ? 'mt-2' : ''"> ریال</span>
                    </vs-td>
                    <vs-td
                      :data="data[indextr].totalAmountAfterDeductionOfDiscounts"
                    >
                      {{
                        Number(
                          data[indextr].totalAmountAfterDeductionOfDiscounts
                        ).toLocaleString()
                      }}
                      ریال
                    </vs-td>
                    <vs-td :data="data[indextr].totalTaxAmount">
                      {{
                        Number(data[indextr].totalTaxAmount).toLocaleString()
                      }}
                      ریال
                    </vs-td>
                    <vs-td :data="data[indextr].price">
                      {{ Number(data[indextr].price).toLocaleString() }} ریال
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <h6 class="text-left shipping-fee">
                {{ $t("ShippingFee") }}:
                {{ Number(order.shippingFee).toLocaleString() }} ریال
              </h6>
              <h6 class="text-left shipping-fee">
                {{ $t("PriceOverhead") }}:
                {{ Number(order.priceOverhead).toLocaleString() }} ریال
              </h6>
              <h5 class="text-left total-price">
                {{ $t("TotalAmountForPayment") }}:
                {{ Number(order.totalAmountForPayment).toLocaleString() }} ریال
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex" v-if="loadTable">
      <div class="vx-col w-full" v-if="!iseditValueOrder">
        <vs-button
          color="success"
          type="gradient"
          icon-pack="feather"
          icon="icon-edit"
          class="mr-4 vs-button float-right"
          @click.prevent="editValueOrder()"
          >{{ $t("Edit") }}</vs-button
        >
        <div>
          <router-link
            :to="{ path: '/Orders/Invoice/' + order.id }"
            class="vs-button purple float-right mt-0"
            v-has-permission="permission"
          >
            {{ $t("Invoice") }}
          </router-link>
        </div>
        <vs-button
                @click="downloadFile(order.id)"
                class="bg_purple float-right ml-4 h-12"
                v-has-permission="permission"
              >
                <feather-icon
                  icon="PlusIcon"
                  svgClasses="h-4 w-4"
                  class="ico"
                />
                {{ $t("DownloadExcelFile") }}
              </vs-button>
      </div>
      <div class="vx-col w-full" v-else>
        <vs-button
          color="success"
          type="gradient"
          icon-pack="feather"
          class="mr-4 vs-button float-right"
          @click.prevent="confirmValueOrder()"
          >{{ $t("Confirm") }}</vs-button
        >
        <vs-button
          type="filled"
          class="float-right ml-4"
          id="cancel-btn"
          @click.prevent="cancelValueOrder()"
          >{{ $t("Cancel") }}</vs-button
        >
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.date {
  font-size: 0.9rem;
  color: #626262;
  font-weight: normal;
}

.total-price {
  background-color: #c8c8c8;
  color: #58595b;
  padding: 1rem;
}

.purple {
  background: #836dd8 !important;
  color: #fff !important;
}

.purple:hover {
  webkit-box-shadow: 0 8px 25px -8px #836dd8;
  box-shadow: 0 8px 25px -8px #836dd8;
}
.shipping-fee {
  padding: 1rem;
  color: #676767;
  font-weight: normal;
}
</style>
<script>
import { mapGetters, mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";

export default {
  name: "saleManagement_Orders_Details",

  data() {
    return {
      permission:'GetExcelOfOrderItems',
      changeState: false,
      unitPriceNewList: [],
      unitDiscountNewList: [],
      sumOfDiscountNewList: [],
      unitPriceOldList: [],
      unitDiscountOldList: [],
      sumOfDiscountOldList: [],
      model: {
        modifyOrderItemsCommand: []
      },
      permission: "GetOrderById",
      loadTable: false,
      iseditValueOrder: false,
      orderId:0,
    };
  },
  computed: {
    ...mapGetters({
      order: "order/details",
      loading: "order/loading"
    })
  },
  mounted() {
    this.load();
    setTimeout(() => {
      this.loadTable = true;
    }, 100);
  },
  methods: {
    ...mapActions({
      exportOrderItemsReportQuery: "excel/exportOrderItemsReportQuery",
      fetchSingle: "order/fetchSingle",
      editOrder: "order/editOrder"
    }),
    downloadFile(id) {
      var params = id;
      this.exportOrderItemsReportQuery({ params });
    },
    load() {
      var id = this.$route.params.id;
      this.fetchSingle(id);
    },
    editValueOrder() {
      this.iseditValueOrder = !this.iseditValueOrder;
    },
    confirmValueOrder() {
      this.iseditValueOrder = !this.iseditValueOrder;
      for (
        let index = 0;
        index < this.order.ordersItemsQueryDto.length;
        index++
      ) {
        this.model.modifyOrderItemsCommand.push({
          productId: this.order.ordersItemsQueryDto[index].orderProductInfoQuery
            .productId,
          unitPrice: this.unitPriceNewList[index],
          unitDiscount: this.unitDiscountNewList[index],
          sumOfDiscount: this.sumOfDiscountNewList[index]
        });
      }
      this.model.orderId = this.$route.params.id;
      this.editOrder(this.model).then(() => {
        setTimeout(() => {
          this.load();
        }, 2000);
      });
    },
    cancelValueOrder() {
      for (
        let index = 0;
        index < this.order.ordersItemsQueryDto.length;
        index++
      ) {
        this.order.ordersItemsQueryDto[index].unitPrice = this.unitPriceOldList[
          index
        ];
        this.order.ordersItemsQueryDto[
          index
        ].unitDiscount = this.unitDiscountOldList[index];
      }
      this.iseditValueOrder = !this.iseditValueOrder;
    },
    commafy(num) {
      var str = num.toString().split(".");
      if (str[0].length >= 5) {
        str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, "$1,");
      }
      if (str[1] && str[1].length >= 5) {
        str[1] = str[1].replace(/(\d{3})/g, "$1 ");
      }

      return str.join(".");
    }
  },
  watch: {
    iseditValueOrder() {
      if (this.iseditValueOrder) {
        for (
          let index = 0;
          index < this.order.ordersItemsQueryDto.length;
          index++
        ) {
          this.unitPriceNewList[index] = this.order.ordersItemsQueryDto[
            index
          ].unitPrice;

          this.unitDiscountNewList[index] = this.order.ordersItemsQueryDto[
            index
          ].unitDiscount
            ? this.order.ordersItemsQueryDto[index].unitDiscount
            : 0;
          this.sumOfDiscountNewList[index] = this.order.ordersItemsQueryDto[
            index
          ].sumOfDiscount
            ? this.order.ordersItemsQueryDto[index].sumOfDiscount
            : 0;
          this.changeState = true;
        }
        this.unitPriceOldList = [...this.unitPriceNewList];
        this.unitDiscountOldList = [...this.unitDiscountNewList];
        this.sumOfDiscountOldList = [...this.sumOfDiscountNewList];
      }
    },
    changeState() {
      for (let index = 0; index < this.unitPriceNewList.length; index++) {
        this.unitPriceNewList[index] = this.commafy(
          this.unitPriceNewList[index]
        );
        this.unitDiscountNewList[index] = this.commafy(
          this.unitDiscountNewList[index]
        );
        this.sumOfDiscountNewList[index] = this.commafy(
          this.sumOfDiscountNewList[index]
        );
      }
    },
    unitPriceNewList(list) {
      for (let index = 0; index < this.unitPriceNewList.length; index++) {
        if (list[index]) {
          var n = parseFloat(list[index].replace(/,/g, ""), 10);
          this.unitPriceNewList[index] = n.toLocaleString();
        }
      }
    },
    unitDiscountNewList(list2) {
      for (let index = 0; index < this.unitDiscountNewList.length; index++) {
        var n = parseFloat(list2[index].replace(/,/g, ""), 10);
        this.unitDiscountNewList[index] = n.toLocaleString();
      }
    },
    sumOfDiscountNewList(list2) {
      for (let index = 0; index < this.sumOfDiscountNewList.length; index++) {
        var n = parseFloat(list2[index].replace(/,/g, ""), 10);
        this.sumOfDiscountNewList[index] = n.toLocaleString();
      }
    }
  }
};
</script>
